import { useEffect, useRef } from 'react';

export default function usePrevious<T = unknown>(value: T): T | undefined {
  const ref = useRef<T>(undefined);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
